import React from "react"
import Select from "react-select"

import {
    sourceTypes,
    publicationTypes,
    contentTypeLabels,
    sourceCountries,
    sourceCountryToRegion,
    regionToParentRegion,
    licenseOptions,
} from "../../../config/application-definitions"

import SelectTags from "../../common/tags/SelectTags"

const sourceStatuses = [
    {
        label: "Active",
        value: true,
    },
    {
        label: "Inactive",
        value: false,
    },
]

const filterCountries = sourceCountries.map((country) => ({
    id: country,
    name: country,
}))

const allRegions = uniquifyAndMakeFilterable(sourceCountryToRegion)
let allParentRegions = uniquifyAndMakeFilterable(regionToParentRegion)
allParentRegions = [
    ...allParentRegions,
    ...allRegions.filter(({ name }) => !regionToParentRegion[name]),
]

function uniquifyAndMakeFilterable(mapping) {
    const allValues = Object.keys(mapping).map((key) => mapping[key])
    return [...new Set(allValues)].map((value) => ({
        id: value,
        name: value,
    }))
}

const SourceFilterForm = ({ model, onEventChange, onValueChange }) => (
    <form name="filterform">
        <div className="filter-block">
            <label>Status</label>
            <select
                className="form-control"
                name="active"
                value={model.active}
                onChange={onEventChange}
            >
                <option value="">All</option>
                {sourceStatuses.map(({ label, value }) => (
                    <option value={value} key={value}>
                        {label}
                    </option>
                ))}
            </select>
        </div>
        <div className="filter-block">
            <label>Type</label>
            <select
                className="form-control"
                name="type"
                value={model.type}
                onChange={onEventChange}
            >
                <option value="">All</option>
                {sourceTypes.map((type) => (
                    <option value={type} key={type}>
                        {type}
                    </option>
                ))}
            </select>
        </div>
        <div className="filter-block">
            <label>Publication type</label>
            <select
                className="form-control"
                name="publication_type"
                value={model.publication_type}
                onChange={onEventChange}
            >
                <option value="">All</option>
                {publicationTypes.map((type) => (
                    <option value={type} key={type}>
                        {type}
                    </option>
                ))}
            </select>
        </div>
        <div className="filter-block">
            <label>Content type</label>
            <select
                className="form-control"
                name="content_type"
                value={model.content_type}
                onChange={onEventChange}
            >
                <option value="">All</option>
                {Object.keys(contentTypeLabels).map((value) => (
                    <option value={value} key={value}>
                        {contentTypeLabels[value]}
                    </option>
                ))}
            </select>
        </div>
        <div className="filter-block">
            <label htmlFor="countries">Countries</label>
            <SelectTags
                name="countries"
                SelectComponent={Select}
                value={model.countries}
                options={filterCountries}
                onChange={onValueChange("countries")}
            />
        </div>
        <div className="filter-block">
            <label htmlFor="regions">Regions</label>
            <SelectTags
                name="regions"
                SelectComponent={Select}
                value={model.regions}
                options={allRegions}
                onChange={onValueChange("regions")}
            />
        </div>
        <div className="filter-block">
            <label htmlFor="greater_regions">Greater regions</label>
            <SelectTags
                name="greater_regions"
                SelectComponent={Select}
                value={model.greater_regions}
                options={allParentRegions}
                onChange={onValueChange("greater_regions")}
            />
        </div>
        <div className="filter-block">
            <label>License</label>
            <select
                className="form-control"
                name="license"
                value={model.license}
                onChange={onEventChange}
            >
                <option value="">All</option>
                {licenseOptions.map((type) => (
                    <option value={type} key={type}>
                        {type}
                    </option>
                ))}
            </select>
        </div>
    </form>
)

export default SourceFilterForm
